/**
 * Бренд — бир жерде. Аты же логотиби өзгөрсө, ушул файл жана
 * `components/Logo.jsx` гана оңдолот (интерфейсти кыдыруунун кереги жок).
 */
export const BRAND = Object.freeze({
  /** Толук аты — өтмөктүн аталышы, тосттор, экспорт */
  name: 'FolioFlow',
  /** Логотиптеги эки бөлүк: биринчиси негизги түс, экинчиси акцент */
  nameParts: Object.freeze(['Folio', 'Flow']),
  tagline: 'Перевод, редактура и корректура книг',
  subtitle: 'ИИ-система издательства',
});

/**
 * Сатуу байланыштары — «Купить полную версию» терезесиндеги баскычтар.
 *
 * ⚠️ Бош болсо баскыч ЖАШЫРЫЛАТ. Мурда бул жерде `https://wa.me/` жана
 * `https://t.me/` деп номерсиз-аккаунтсуз жазылып турган: кардар басса эч
 * нерсе болбойт — сатуунун эң негизги баскычы иштебей турган.
 *
 *   whatsapp — эл аралык форматтагы номер, сандар гана: '996555123456'
 *   telegram — аккаунттун аты, @'сиз: 'folioflow'
 */
export const CONTACTS = Object.freeze({
  whatsapp: '996550956566',
  telegram: 'azacoder',
});
